{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Zobrazit všechny možnosti",
  "Spoiler_Reveal_Tooltip": "Pro zobrazení klikněte",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweetovat",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Položka je zabalena",
  "Spoiler_Reveal_Video_CTA": "Odkrýt video",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Roztáhnout obrázek",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Zobrazit všechny výsledky",
  "Spoiler_Reveal_Image_Placeholder": "Tento obrázek obsahuje spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Posuvník hledání",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Můžete hlasovat pro více jak jednu odpověď.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Zobrazit další ovládací prvky zvuku",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Zavřít",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Načítání {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Použít avatara",
  "Preview_ReadMore_Label": "Zjistit více",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Objem",
  "Spoiler_Reveal_Gallery_Placeholder": "Tato galerie obsahuje spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Rezervovat",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Zrušit ztlumení",
  "Spoiler_Reveal_Gallery_CTA": "Odkrýt galerii",
  "Poll_Viewer_ShowLess_CTA": "Zobrazit méně",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Ztlumit",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonymně",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Sledovat",
  "VerticalEmbed_Products_Button": "Koupit",
  "Poll_Viewer_Toast_Error_ServerDown": "Nepodařilo se připojit k serveru. Zkuste to později.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "Pro tuto odpověď hlasoval {{count}} uživatel",
  "Poll_Viewer_VoteCount": "Hlasů {{number}}",
  "VerticalEmbed_Events_Button": "Registrovat",
  "Spoiler_Reveal_Image_CTA": "Odkrýt obrázek",
  "Poll_Viewer_Toast_Error_Connection": "Internet není k dispozici. Zkontrolujte připojení.",
  "Poll_Viewer_Visibility_Owner_Footer": "Výsledky uvidíte pouze vy.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "Pro tuto odpověď hlasovalo uživatelů: {{count}}",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Položka je rozbalena",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Toto video obsahuje spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Zobrazit celý příspěvek",
  "UploadFile_Viewer_Download": "Stáhnout {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} h",
  "VerticalEmbed_Units_Minute": "{{minutes}} min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
